<template>
  <div id="app" class="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  // 使用watch 监听$router的变化,
  watch: {
    '$route': function(to,from){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
<style>
.app {
  width:100%;
  height:100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue